import { Meal, OrderHistoryReceiptMeal } from '@tovala/browser-apis-combinedapi'
import { ReactNode } from 'react'

import DetailsDialog from './DetailsDialog'
import { MealDetails } from './MealDetails'
import { CookTime, ExpirationDate } from './shared'
import { DialogTitle } from '@headlessui/react'

const MealDetailsDialog = ({
  closeModal,
  imageTag,
  meal,
  orderStatus,
  price,
  review,
  stepper,
}: {
  closeModal(): void
  imageTag?: ReactNode
  meal: Meal | OrderHistoryReceiptMeal
  orderStatus?: ReactNode
  price?: ReactNode
  review?: ReactNode
  stepper?: ReactNode
}) => {
  return (
    <DetailsDialog onClose={closeModal}>
      <div className="flex-auto overflow-y-auto">
        <MealDetails
          cookTime={
            <CookTime
              mealID={meal.id}
              routineMetadataObjects={meal.routineMetadataObjects}
            />
          }
          expirationDate={
            <ExpirationDate expirationDate={meal.expirationDate} />
          }
          imageTag={imageTag}
          meal={meal}
          price={price}
          review={review}
          stepper={stepper}
          title={<DialogTitle>{meal.title}</DialogTitle>}
        />
      </div>

      {orderStatus}
    </DetailsDialog>
  )
}

export default MealDetailsDialog
